export function stringFormat(...arg: any[]): string {
  let result = arg[0]
  if (arg.length > 1) {
    if (arg.length == 2 && typeof arg[1] == "object") {
      const args = arg[1]
      for (const key in args) {
        if (args[key] != undefined) {
          const reg = new RegExp("({" + key + "})", "g")
          result = result.replace(reg, args[key])
        }
      }
    } else {
      for (let i = 1; i < arg.length; i++) {
        if (arg[i] != undefined) {
          const reg = new RegExp("({[" + (i - 1) + "]})", "g")
          result = result.replace(reg, arg[i])
        }
      }
    }
  }
  return result
}

/**
 * 增加外链校验,域名规则
 * @param url
 */
export function redirectOut(url: string): void {
  if (/^(https?:\/\/)?[\w\-.]+\.(qq|paipai|soso|taotao|weiyun)\.com($|\/|\\)/i.test(url)) {
    location.href = url
  }
}

/**
 * 判断时间是否有效
 * @param {} date
 */
export function isValidDate(date: string | Date | undefined): boolean {
  return date instanceof Date && !isNaN(date.getTime())
}
